module.exports = __webpack_public_path__ + "img/alloxentric.fbdcbe1f.png";